<template>

    <div class="content-wrap">
      <div class="register-wrap">
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="관리번호">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.companyParams.cmp_info_seq" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="회사">
                <template #end="{id}" >
                  <ElInput :id="id" ref="cmpNmRef" v-model="state.tmpVal.cmp_nm" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="사업부명" >
                  <template #end="{id}">
                    <div class="input-group">
                      <ElInput :id="id" ref="cmpDvsnNmRef" v-model="state.tmpVal.cmp_dvsn_nm" readonly/>
                    </div>  
                  </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="사업자 등록 번호">
                <template #end="{id}">
                  <ElInput :id="id" ref="businessNoRef" v-model="state.companyParams.business_no" :maxlength='12' readonly />
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
                <ElLabel name="전화번호">
                  <template #end="{id}">
                    <ElInput :id="id" ref="telNoRef" v-model="state.companyParams.tel_no" :maxlength="12" readonly />
                  </template>
                </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="대표자">
                <template #end="{id}">
                  <ElInput :id="id" ref="ceoRef" v-model="state.companyParams.ceo_nm" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
                <ElLabel name="팩스번호">
                  <template #end="{id}">
                    <ElInput :id="id" ref="faxRef" v-model="state.companyParams.fax_no" readonly />
                  </template>
                </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="홈페이지">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.companyParams.homepage" readonly />
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <ElLabel name="주소">
                <template #end="{id}">
                  <div class="input-group mb-3">
                    <ElInput :id="id" ref="addressRef" v-model="state.companyParams.address" readonly/>
                  </div>
                </template>
              </ElLabel>  
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
  
              <ElLabel name="상세주소">
                <template #end="{id}">
                  <ElInput :id="id" ref="addressDtlRef" v-model="state.companyParams.address_dtl" readonly/>
                </template>
              </ElLabel>
  
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
  
              <ElLabel name="업태/업종">
                <template #end="{id}">
                  <ElInput :id="id" ref="sectRef" v-model="state.companyParams.sector" readonly/>
                </template>
              </ElLabel>
  
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="업데이트 날짜">
                <template #end="{id}">
                  <DatePicker 
                  :id="id" 
                  v-model="state.companyParams.fmt_upd_dt"
                  readonly
                  />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="담당자" >
                <template #end="{id}">
                  <div class="input-group">
                    <ElInput :id="id" v-model="state.companyParams.mngr_nm" readonly/>
                  </div>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
  
        <div class="row band">
          <div class="col-md-6">
            <div class="mb-3">
              <ElLabel name="Activity(Marketing inform)">
                <template #end="{id}">
                  <ElTextarea 
                    v-model="state.companyParams.activity"
                    :id="id"
                    :rows="3"
                    disabled
                  />
                </template>
              </ElLabel>
              
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <ElLabel name="메모">
                <template #end="{id}">
                  <ElTextarea 
                    v-model="state.companyParams.note"
                    :id="id"
                    :rows="3"
                    disabled
                  />
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
  
        <div class="row band">
          <div class="col-md-3">
            <div class="mb-3">
  
              <ElLabel name="활성화/비활성화">
                <template #end="{id}">
                  <div class="radio-btn-toggle d-flex">
                    <ElLabel name="활성화" classNm="btn btn-sm flex-fill">
                      <template #start="{id}">
                        <ElRadio
                          :id="id"
                          classNm="btn-check"
                          :value="true"
                          v-model="state.companyParams.enable_yn"
                          readonly
                        />
                      </template>
                    </ElLabel>
  
  
                    <ElLabel name="비활성화" classNm="btn btn-sm flex-fill">
                      <template #start="{id}">
                        <ElRadio
                          :id="id"
                          classNm="btn-check"
                          :value="false"
                          v-model="state.companyParams.enable_yn"
                          disabled
                        />
                      </template>
                    </ElLabel>
                  </div>
                  
                </template>
              </ElLabel>
  
              
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="즐겨찾기">
                <template #end="{id}">
                  <ElButton
                    :id="id"
                    type="bookmarkL"
                    :active="state.companyParams.bkmark_yn == 'Y'"
                    disabled
                    
                  >
                    즐겨찾기
                  </ElButton>
                </template>
              </ElLabel>
              
            </div>
          </div>
        </div>
        <!--todo : captionList 공통컴포넌트 적용-->
        <div class="row">
          <Caption
            ref="captionRef"
            :tbId="'cmp'"
            :cap_seq="state.companyParams.cp_seq"
            :readonly="true"
          />
        </div>
      </div>
      <!-- //register-wrap -->
  
      <div class="text-end py-3">
        <ElButton type="primary" @buttonClick="router.back()">이전</ElButton>
      </div>  
      <div class="accordion" id="accordionPanelsStayOpenExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <ElButton
              type="accordionHeader"
              target="panelsStayOpen-collapseOne"
            >
              첨부파일
            </ElButton>
          </h2>
          <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse">
            <div class="accordion-body accordion-body-register">
              <FileUpload ref="fileUploadRef" :canUpdate="false"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- //container -->
  </template>
  
  <script setup>
  import { reactive, ref, onBeforeMount } from "vue";
  import Caption from '@/components/common/CaptionList.vue';
  
  import { useRouter } from "vue-router";
  
  import DatePicker from "@/components/common/DatePicker.vue";
  import FileUpload from "@/components/common/FileUpload.vue";
  
  import { useLoading } from '@/composable/Loading.js'
  const { setIsLoading } = useLoading()
  import { compSelect } from "@/api/comp";
  import { fileList } from "@/api/file";
  
  const router = useRouter();
  
  const fileUploadRef = ref();
  
  const cmpNmRef = ref();
  const cmpDvsnNmRef = ref();
  const businessNoRef = ref();
  const telNoRef = ref()
  const ceoRef = ref();
  const faxRef = ref()
  const sectRef = ref();
  const addressRef = ref();
  const addressDtlRef = ref();
  const captionRef = ref();
  
onBeforeMount(async () => {
  let cp_seq = history.state.cp_seq;
  if(cp_seq){
    searchCmpDtl(cp_seq)
  }else{
    alert('잘못된 접근입니다.')
    router.back()
  }
});
  
async function searchCmpDtl(cp_seq){
  let param = {
    cp_seq: cp_seq,
  };
  try {
    setIsLoading(true)
    const res = await compSelect(param)
    if(Object.keys(res.rtn).length === 0){
      alert('조회되는 회사가 없습니다.확인 후 다시 조회해주세요')
      router.push('/cp/MCP_CR_002')
      return
    }
    let detailCp = res.rtn;
    state.companyParams.note = detailCp.note;
    state.companyParams.activity = detailCp.activity;
    state.companyParams.cmp_seq = detailCp.cmp_seq;
    state.companyParams.enable_yn = detailCp.enable_yn;

    if (state.companyParams.enable_yn == "Y") {
      state.companyParams.enable_yn = true;
    } else {
      state.companyParams.enable_yn = false;
    }

    state.companyParams.bkmark_yn = detailCp.bkmark_yn;
    state.companyParams.cp_seq = detailCp.cp_seq;
    state.companyParams.ceo_nm = detailCp.ceo_nm;
    state.companyParams.mng_seq = detailCp.mng_seq;
    state.companyParams.cap_seq =
      detailCp.cap_seq == "" ? 0 : detailCp.cap_seq;
    state.companyParams.tel_no = detailCp.tel_no;
    state.companyParams.cmp_info_seq = detailCp.cmp_info_seq;
    state.companyParams.sector = detailCp.sector;

    state.companyParams.sr = detailCp.sr;
    state.companyParams.map_ck = detailCp.map_ck;

    state.tmpVal.cmp_dvsn_nm = detailCp.cmp_dvsn_nm;
    state.tmpVal.cmp_nm = detailCp.cmp_nm;

    state.companyParams.cmp_nm = detailCp.cmp_nm;
    state.companyParams.cmp_dvsn_nm = detailCp.cmp_dvsn_nm;

    state.originVal.cmp_nm = detailCp.cmp_nm;
    state.originVal.cmp_dvsn_nm = detailCp.cmp_dvsn_nm;

    state.companyParams.business_no = detailCp.business_no;
    state.companyParams.am = detailCp.am;
    state.companyParams.end_yn = detailCp.end_yn;
    state.companyParams.tmp_yn = detailCp.tmp_yn;
    state.companyParams.address = detailCp.address;
    state.companyParams.address_dtl = detailCp.address_dtl;

    state.companyParams.fax_no = detailCp.fax_no;
    state.companyParams.homepage = detailCp.homepage;
    state.companyParams.fmt_upd_dt = detailCp.fmt_upd_dt;

    state.dupCheck = true;

    //첨부파일이 존재할경우 파일리스트 조회api 호출
    if (
      detailCp.file_seq_grp != "" &&
      detailCp.file_seq_grp != null &&
      detailCp.file_seq_grp != undefined
    ) {
      let apiParam = {
        file_seq_grp: detailCp.file_seq_grp,
      };
      try {
        const resFileList = await fileList(apiParam)
        fileUploadRef.value.state.fileParams.fileListVo = resFileList.rtn;
      } catch (err) {
        console.log("파일리스트 조회 api 에러", err);
        alert("파일리스트 조회에 실패했습니다.");
        throw err
      }
    }
  } catch (err) {
    console.log("회사 상세조회 api 에러", err);
    alert("회사 상세 조회에 실패했습니다.");
    router.push("/cp/MCP_CR_002");
  } finally {
    setIsLoading(false)
  }
}
  const state = reactive({
    companyParams: {
      cp_seq: "",
      cmp_nm: "",
      cmp_dvsn_nm: "",
      mngr_nm :"",
      note: "",
      activity: "",
      cmp_seq: 5,
      // enable: true,
      enable_yn: true,
      bkmark_yn: "N",
      ceo_nm: "",
      mng_seq: null,
      cap_seq: 5,
      tb_id: "cmp",
      tel_no: "",
      cmp_info_seq: "",
      sector: "",
      sr: "",
      map_ck: "N",
      business_no: "",
      am: "",
      end_yn: "",
      tmp_yn: "",
      address: "",
      address_dtl: "",
      fax_no: "",
      homepage: "",
      upt_dt: "",
      attachFileVO: {
        file_div_id: "10",
        file_seq: "", //추가 된 파일 seq 전송
        del_file_seq: "", // 삭제해야 할 파일 seq 전송
      },
    },
    managerNm: "",
    dupCheck: false,
    tmpVal: {
      cmp_nm: "",
      cmp_dvsn_nm: "",
    },
    //파일 첨부 데이터()
    fileList: [],
    delFileList: [],
    originVal: {
      cmp_nm: "",
      cmp_dvsn_nm: "",
    },
  });
  
  </script>